var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"justify":"center"}},[_c('v-dialog',{attrs:{"max-width":"1000px","persistent":""},model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}},[_c('v-form',{ref:"form"},[_c('vue-daum-postcode',{on:{"complete":_vm.closeDialog}}),_vm._v(" /> ")],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }